//import react functions
import { useEffect, useState } from "react";
import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";

//import styles
import "./Register.css";
import ReCAPTCHA from "react-google-recaptcha";
import { ApiConnectionString } from "../../constants/ApiConntection";
import CheckEmailModal from "./modals/CheckEmailModal";
import MemboticLogo from "../../assets/MemboticLogo.png";
import { Link } from "react-router-dom";

export default function Register() {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState("");
  const [username, setUsername] = useState("");
  const [usernameErr, setUsernameErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [registerErr, setRegisterErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [checkEmailModal, setCheckEmailModal] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [dateOfBirthErr, setDateOfBirthErr] = useState("");
  const [postCode, setPostCode] = useState("");
  const [postCodeErr, setPostCodeErr] = useState("");
  const [capVal, setCapVal] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryErr, setSelectedCountryErr] = useState("");
  const countryOptions = [
    { code: "GB", name: "United Kingdom" },
    { code: "US", name: "United States" },
    { code: "CA", name: "Canada" },
    { code: "AU", name: "Australia" },
  ];

  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const isOver18 = (dateOfBirth) => calculateAge(dateOfBirth) >= 18;

  const usernameRegex = /^[\w\d\s-']+$/;
  const nameRegex = /^[A-Za-z\s-']+$/;

  const strongRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,300})"
  );
  const UK_POSTCODE_REGEX = /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i;
  const US_ZIPCODE_REGEX = /^\d{5}(-\d{4})?$/;
  const CA_POSTCODE_REGEX = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i;
  const AU_POSTCODE_REGEX = /^\d{4}$/;

  const cancelModal = () => {
    setCheckEmailModal(false);
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    let err = false;
    setUsernameErr("");
    setConfirmPasswordErr("");
    setPasswordErr("");
    setDateOfBirthErr("");
    setFirstNameErr("");
    setLastNameErr("");
    setEmailErr("");
    setSelectedCountryErr("");

    //country error
    if (
      selectedCountry !== "GB" &&
      selectedCountry !== "US" &&
      selectedCountry !== "CA" &&
      selectedCountry !== "AU"
    ) {
      err = true;
      setSelectedCountryErr("Please select a country.");
    }

    //postcode validation
    if (!capVal) {
      err = true;
    }
    if (selectedCountry === "UK" && !UK_POSTCODE_REGEX.test(postCode)) {
      err = true;
      setPostCodeErr("Postcode must be a valid UK postcode.");
    } else if (selectedCountry === "US" && !US_ZIPCODE_REGEX.test(postCode)) {
      err = true;
      setPostCodeErr("Postcode must be a valid US ZIP code.");
    } else if (selectedCountry === "CA" && !CA_POSTCODE_REGEX.test(postCode)) {
      err = true;
      setPostCodeErr("Postcode must be a valid Canadian postal code.");
    } else if (selectedCountry === "AU" && !AU_POSTCODE_REGEX.test(postCode)) {
      err = true;
      setPostCodeErr("Postcode must be a valid Australian postcode.");
    }
    // Username Validations
    if (username.length < 3) {
      err = true;
      setUsernameErr(
        "Username is too short. It must be at least 3 characters long"
      );
    }
    if (username.length > 15) {
      err = true;
      setUsernameErr("Username is too long. It must not be over 15 characters");
    }
    if (!usernameRegex.test(username)) {
      err = true;
      setUsernameErr(
        "Your username can only include letters, numbers, spaces, hyphens, underscores, and apostrophes."
      );
    }

    // Email Validations
    if (email.length > 150) {
      err = true;
      setEmailErr(
        "Your email address exceeds the maximum length of 150 characters"
      );
    }
    if (email.length < 3) {
      err = true;
      setEmailErr("Your email is too short");
    }

    // Password Validations
    if (!strongRegex.test(password)) {
      err = true;
      setPasswordErr(
        "Password must be at least 8 characters in length and contain at least 1 uppercase, lowercase, number, and special character (e.g., $tr0ngPa55w0rd!)."
      );
    }
    if (password != confirmPassword) {
      err = true;
      setConfirmPasswordErr("Passwords do not match");
    }

    // First Name Validations
    if (!nameRegex.test(firstName)) {
      err = true;
      setFirstNameErr(
        "Your first name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (firstName.length < 2) {
      err = true;
      setFirstNameErr(
        "Your first name is too short. It must be at least 2 characters long"
      );
    }
    if (firstName.length > 50) {
      err = true;
      setFirstNameErr(
        "Your first name is too long. It must not be over 50 characters"
      );
    }

    // Last Name Validations
    if (!nameRegex.test(lastName)) {
      err = true;
      setLastNameErr(
        "Your last name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (lastName.length < 2) {
      err = true;
      setLastNameErr(
        "Your last name is too short. It must be at least 2 characters long"
      );
    }
    if (lastName.length > 50) {
      err = true;
      setLastNameErr(
        "Your last name is too long. It must not be over 50 characters"
      );
    }

    // Date of Birth Validations
    if (!dateOfBirth) {
      err = true;
      setDateOfBirthErr("Date of Birth is required");
    } else if (!isOver18(dateOfBirth)) {
      err = true;
      setDateOfBirthErr("You must be at least 18 years old");
    }

    const registerDetails = {
      username,
      email,
      password,
      firstName,
      lastName,
      dateOfBirth,
      postCode,
      country: selectedCountry,
    };

    if (!err) {
      try {
        const signUpResponse = await axios.post(
          `${ApiConnectionString}/api/PendingAccount`,
          registerDetails
        );

        if (signUpResponse.status == 200) {
          setUsernameErr("");
          setConfirmPasswordErr("");
          setPasswordErr("");
          setDateOfBirthErr("");
          setFirstNameErr("");
          setLastNameErr("");
          setEmailErr("");
          setCheckEmailModal(true);
        } else {
          // Handle unexpected status codes if needed
          console.error("Unexpected status code:", signUpResponse.status);
        }
      } catch (err) {
        if (err.response && err.response.status == 400) {
          // Use the error response data directly
          setRegisterErr(err.response.data);
        } else {
          // Handle other types of errors or unexpected responses
          setRegisterErr(
            "An unexpected error occurred. Please try again later."
          );
        }
      } finally {
        // Stop loading regardless of success or failure
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="d-flex">
        {isLoading && <LoadingSpinner />}

        <form onSubmit={handleSubmit} className="register-form">
          <div className="text-center">
            {" "}
            <img
              src={MemboticLogo}
              className="logo"
              alt="Membotic"
              title="Membotic"
            />
          </div>

          <p className="text-center">
            Register to create an account and make use of Membotic
          </p>
          <label>
            <span>Username:</span>
            <input
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, "");
                setUsername(value);
              }}
              value={username}
            />
          </label>
          {usernameErr && <p className="text-danger">{usernameErr}</p>}
          <label>
            <span>Email:</span>
            <input
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </label>
          {emailErr && <p className="text-danger">{emailErr}</p>}
          <label>
            <span>First Name:</span>
            <input
              onChange={(e) => setFirstName(e.target.value)}
              value={firstName}
            />
          </label>
          {firstNameErr && <p className="text-danger">{firstNameErr}</p>}
          <label>
            <span>Last Name:</span>
            <input
              onChange={(e) => setLastName(e.target.value)}
              value={lastName}
            />
          </label>
          {lastNameErr && <p className="text-danger">{lastNameErr}</p>}
          <label>
            <span>Date of birth:</span>

            <input
              type="date"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              required
            />
          </label>
          {dateOfBirthErr && <p className="text-danger">{dateOfBirthErr}</p>}

          <label>
            <span>Country:</span>
            <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="">Select a country</option>
              {countryOptions.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </label>

          <label>
            <span>{selectedCountry === "US" ? "Zipcode:" : "Postcode:"}</span>

            <input
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
              required
            />
          </label>
          {/* {registerErr && registerErr == "Invalid postcode" && (
            <p className="text-danger">{registerErr}</p>
          )} */}
          {postCodeErr && <p className="text-danger">{postCodeErr}</p>}

          {selectedCountryErr && (
            <p className="text-danger">{selectedCountryErr}</p>
          )}

          <label className="position-relative">
            <span>Password:</span>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="pe-5"
              />
              <span
                className="position-absolute end-0 top-50 translate-middle-y px-2 pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>
          </label>
          {passwordErr && <p className="text-danger">{passwordErr}</p>}

          <label className="position-relative">
            <span>Confirm Password:</span>
            <div className="position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                className="pe-5"
              />
              <span
                className="position-absolute end-0 top-50 translate-middle-y px-2 pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </span>
            </div>
          </label>
          {confirmPasswordErr && (
            <p className="text-danger">{confirmPasswordErr}</p>
          )}

          <div className="d-flex">
            <input
              type="checkbox"
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              className="mx-4"
            />
            <span className="mt-3">
              I agree to the <Link to="/termsofUse">Terms and Conditions</Link>
            </span>
          </div>

          <div className="m-3">
            <ReCAPTCHA
              sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
              onChange={(val) => setCapVal(val)}
            />
          </div>
          {capVal && agreeToTerms && (
            <div className="text-center">
              <button disabled={isLoading} className="signUpButton">
                Signup
              </button>
            </div>
          )}
          {/* {registerErr && <p className="text-danger">{registerErr}</p>} */}
        </form>
        {checkEmailModal && <CheckEmailModal cancelModal={cancelModal} />}
      </div>
    );
  }
}
